import React, {useEffect, useState} from 'react';
import {getServersAPI, updateServerAPI} from "./api";
import Header from "./common/header/header";
import classes from "./admin.module.css";

const Servers = () => {
    const [data, setData] = useState([])

    const getServers = async ()=>{
        const res = await getServersAPI()
        if(res){
            setData(res)
        }
    }

    useEffect(()=>{
        getServers()
    },[])

    async function updateOnline(){
        // Устанавливаем всем серверам состояние loading
        setData(prevData => prevData.map(server => ({
            ...server,
            server_online: 'loading'
        })))

        // Обновляем каждый сервер последовательно
        for(let i = 0; i < data.length; i++) {
            let res = await updateServerAPI(data[i].server_id)
            // Обновляем конкретный сервер с результатом
            setData(prevData => prevData.map(server =>
                server.server_id === data[i].server_id
                    ? { ...server, server_online: res === true }
                    : server
            ))
        }
        await getServers()
    }

    return (
        <div className={classes._}>
            <Header/>
            <table className={classes.table} align="center" border="1">
                <tr>
                    <td className={classes.tableHeader}>Клиент</td>
                    <td className={classes.tableHeader}>Страна</td>
                    <td className={classes.tableHeader}>IP</td>
                    <td className={classes.tableHeader}>Всего</td>
                    <td className={classes.tableHeader}>Онлайн</td>
                    <td className={classes.tableHeader}>Из РФ</td>
                </tr>
                {data.map(item=>
                    <tr key={item.id}>
                        <td className={classes.tableText}>{item.server_client}</td>
                        <td className={classes.tableText}>{item.server_country}</td>
                        <td className={classes.tableText}>
                            {item.server_client.split(' ')[0]!=='VLESS' ? <a target="_blank" className={classes.tableText} href={`http://${ item.server_ip }:${ item.server_port }`}>{item.server_ip}</a> :
                                <a target="_blank" className={classes.tableText} href={`https://${ item.server_ip }`}>{item.server_ip.split('/')[0]}</a>}
                        </td>
                        <td className={classes.tableText}>{item.count_all}</td>
                        <td className={classes.tableText}>{item.server_online === "loading"?'⏳':item.server_online?'✅':'❌'}</td>
                        <td className={classes.tableText}>
                            {item.reachable_from_ru === undefined || item.reachable_from_ru === null
                                ? '—'
                                : item.reachable_from_ru ? '✅' : '❌'}
                        </td>
                    </tr>
                )}
                <tr>
                    <td className={classes.tableHeader}>Всего</td>
                    <td></td>
                    <td></td>
                    <td className={classes.tableHeader}>{data.reduce((sum, item) => sum + item.count_all, 0)}</td>
                </tr>
            </table>
            <button onClick={updateOnline}>Обновить онлайн</button>
        </div>
    );
};

export default Servers;